import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../../../utils/string-helpers";

export const EmptyFood = ({ label = "foods", variant = "added" }) => {
  const { t } = useTranslation("athlete-portal");
  const resolvedLabel = label === "all" ? "foods" : label;
  const labelCapitalized = capitalizeFirstLetter(resolvedLabel);
  const singularLabel = (() => {
    const w = resolvedLabel;
    return w.endsWith("s") ? w.slice(0, -1) : w;
  })();

  /**
   * Get the title to use
   * @param {*} type
   * @returns
   */
  const getTitle = (type) => {
    if (type === "recent") {
      return t("emptyFood.noRecentYet", { label: labelCapitalized });
    }
    return t("emptyFood.noAdded", { singularLabel });
  };

  /**
   * Get the subtitle to use
   * @param {*} type
   * @returns
   */
  const getSubtitle = (type) => {
    if (type === "recent") {
      return t("emptyFood.subtitleRecent", { label: resolvedLabel });
    }
    if (type === "meal") {
      return t("emptyFood.subtitleMeal", { singularLabel });
    }
    return t("emptyFood.subtitlePlanner", { singularLabel });
  };

  const titleMap = {
    added: getTitle("added"),
    meal: getTitle("meal"),
    recent: getTitle("recent"),
  };

  const subtitleMap = {
    added: getSubtitle("added"),
    meal: getSubtitle("meal"),
    recent: getSubtitle("recent"),
  };

  return (
    <div className="no-content">
      <div className="flex flex-col gap-4 items-center">
        <span className="font-bold">{titleMap[variant]}</span>
        <span className="opacity-70 text-center w-[70%] text-[0.75rem]">
          {subtitleMap[variant]}
        </span>
      </div>
    </div>
  );
};

EmptyFood.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf(["added", "recent", "meal"]),
};
